import { createGetPropGetter } from '@/store/utils';

export default {
  amountOfRunningProjects: createGetPropGetter('amountOfRunningProjects', {}),
  lastAddingConfigurationActionData: createGetPropGetter('lastAddingConfigurationActionData', {
    running: false,
    configType: null,
  }),
  deleteConfigurationLoading: createGetPropGetter('deleteConfigurationLoading', false),
  subdomainsForTld: createGetPropGetter('subdomainsForTld', []),
  emailsForTld: createGetPropGetter('emailsForTld', []),
  hostsForSubdomain: createGetPropGetter('hostsForSubdomain', []),
  lastCTCNode: createGetPropGetter('lastCTCNode', {}),
  riskScoreHistoryPerTld: createGetPropGetter('riskScoreHistoryPerTld', {}),
  projectListLoading: createGetPropGetter('projectListLoading', false),
  dataLoading: createGetPropGetter('dataLoading', false),
  configurationCloudAssets: createGetPropGetter('configurationCloudAssets', []),
  configurationBucketAssets: createGetPropGetter('configurationBucketAssets', []),
  configurationServicesAssets: createGetPropGetter('configurationServicesAssets', []),
  configurationServicesComplianceOptions: createGetPropGetter('configurationServicesComplianceOptions', {}),
  servicesAssetsListOptions: createGetPropGetter('servicesAssetsListOptions', {}),
  cloudServicesSecondLevelItems: createGetPropGetter('cloudServicesSecondLevelItems', []),
  cloudServicesThirdLevelItems: createGetPropGetter('cloudServicesThirdLevelItems', []),
  cloudServicesFourthLevelItems: createGetPropGetter('cloudServicesFourthLevelItems', {}),
  configurationSubdomains: createGetPropGetter('configurationSubdomains', []),
  configurationHosts: createGetPropGetter('configurationHosts', []),
  configurationDomains: createGetPropGetter('configurationDomains', []),
  cloudAccountsListOptions: createGetPropGetter('cloudAccountsListOptions', {}),
  configurationCloudAccounts: createGetPropGetter('configurationCloudAccounts', []),
  configurationDomainTags: createGetPropGetter('configurationDomainTags', []),
  configurationCloudAccountTags: createGetPropGetter('configurationCloudAccountTags', []),
  configurationSubdomainTags: createGetPropGetter('configurationSubdomainTags', []),
  configurationOrganizationTags: createGetPropGetter('configurationOrganizationTags', []),
  configurationAuthenticationObjects: createGetPropGetter('configurationAuthenticationObjects', []),
  cloudAccountsTags(state) {
    const tagsPerAccount = {};
    if (state.configurationCloudAccounts && state.configurationCloudAccountTags) {
      const {configurationCloudAccounts, configurationCloudAccountTags} = state;
      for (let i = 0; i < configurationCloudAccounts.length; i += 1) {
        const currentAccount = configurationCloudAccounts[i];
        tagsPerAccount[currentAccount.configData] = currentAccount.tags || {};
      }
      for (let i = 0; i < configurationCloudAccountTags.length; i += 1) {
        const currentAccount = configurationCloudAccountTags[i];
        if (Object.keys(tagsPerAccount).includes(currentAccount.configData)) {
          tagsPerAccount[currentAccount.configData] = { ...tagsPerAccount[currentAccount.configData], ...currentAccount.tags } || {};
        } else {
          tagsPerAccount[currentAccount.configData] = currentAccount.tags || {};
        }
      }
    }
    return tagsPerAccount;
  },
  domainsTags(state) {
    const tagsPerDomain = {};
    if (state.configurationDomains && state.configurationDomainTags) {
      const {configurationDomains, configurationDomainTags} = state;
      for (let i = 0; i < configurationDomains.length; i += 1) {
        const currentDomain = configurationDomains[i];
        tagsPerDomain[currentDomain.configData] = currentDomain.tags || {};
      }
      for (let i = 0; i < configurationDomainTags.length; i += 1) {
        const currentDomain = configurationDomainTags[i];
        if (Object.keys(tagsPerDomain).includes(currentDomain.configData)) {
          tagsPerDomain[currentDomain.configData] = { ...tagsPerDomain[currentDomain.configData], ...currentDomain.tags } || {};
        } else {
          tagsPerDomain[currentDomain.configData] = currentDomain.tags || {};
        }
      }
    }
    return tagsPerDomain;
  },
  subdomainsTags(state) {
    const tagsPerSubdomain = {};
    if (state.configurationSubdomains && state.configurationSubdomainTags) {
      const {configurationSubdomains, configurationSubdomainTags} = state;
      for (let i = 0; i < configurationSubdomains.length; i += 1) {
        const currentSubdomain = configurationSubdomains[i];
        tagsPerSubdomain[currentSubdomain.configData] = currentSubdomain.tags || {};
      }
      for (let i = 0; i < configurationSubdomainTags.length; i += 1) {
        const currentSubdomain = configurationSubdomainTags[i];
        if (Object.keys(tagsPerSubdomain).includes(currentSubdomain.configData)) {
          tagsPerSubdomain[currentSubdomain.configData] = { ...tagsPerSubdomain[currentSubdomain.configData], ...currentSubdomain.tags } || {};
        } else {
          tagsPerSubdomain[currentSubdomain.configData] = currentSubdomain.tags || {};
        }
      }
    }
    return tagsPerSubdomain;
  },
  panoramicData: createGetPropGetter('panoramicData', null),
  testCards: createGetPropGetter('testCards', {}),
  testCardsDomains: createGetPropGetter('testCardsDomains', {}),
  testCardsDomainsLastScannedDate: createGetPropGetter('testCardsDomainsLastScannedDate', {}),
  testCardsPasswordSpray: createGetPropGetter('testCardsPasswordSpray', {}),
  testCardsSubdomains: createGetPropGetter('testCardsSubdomains', {}),
  testCardsCloudAccounts: createGetPropGetter('testCardsCloudAccounts', {}),
  hasDiscoveryFinished: createGetPropGetter('hasDiscoveryFinished', {}),
  testCardsHosts: createGetPropGetter('testCardsHosts', {}),
  testTypes: createGetPropGetter('testTypes', []),
  projects: createGetPropGetter('projects', []),
  projectLoading: createGetPropGetter('projectLoading', false),
  detailedProject: createGetPropGetter('detailedProject', null),
  projectListOptions: createGetPropGetter('projectListOptions', {}),
  projectsListSort(state, { projectListOptions = {} }) {
    return projectListOptions.sort || {};
  },
  portsToScoreMap: createGetPropGetter('portsToScoreMap', {}),
  addTagsIntervalRunning: createGetPropGetter('addTagsIntervalRunning', false),
  addTagsRefId: createGetPropGetter('addTagsRefId', ''),
  projectsRunningInterval: createGetPropGetter('projectsRunningInterval', false),
  projectsProgress: createGetPropGetter('projectsProgress', 0),
  projectsRefId: createGetPropGetter('projectsRefId', ''),
};
